export default __webpack_public_path__ + "images/H6.c71717f.png";